import React from 'react';
import './SourcedLogo.css';

/*
 * Brand marks pulled from the iOS app's asset catalog
 * (SourcedEmblem + SourcedWordmark). Both are alpha-masked PNGs that iOS
 * renders as templates, so here they are painted through a CSS mask and
 * take their colour from `currentColor`, same as the app.
 */

const WORDMARK_RATIO = 610 / 233; // px width / height of wordmark.png
const EMBLEM_RATIO = 263 / 294;   // px width / height of emblem.png

export function SourcedEmblem({ height = 28, className = '', style }) {
  return (
    <span
      className={`sourced-mark sourced-emblem ${className}`.trim()}
      style={{ height, width: Math.round(height * EMBLEM_RATIO), ...style }}
      aria-hidden="true"
    />
  );
}

export function SourcedWordmark({ height = 22, className = '', style }) {
  return (
    <span
      className={`sourced-mark sourced-wordmark ${className}`.trim()}
      style={{ height, width: Math.round(height * WORDMARK_RATIO), ...style }}
      aria-hidden="true"
    />
  );
}

/** Emblem + hand-drawn wordmark, sized by the wordmark height (like iOS). */
export default function SourcedLogo({ height = 22, showEmblem = true, className = '' }) {
  return (
    <span
      className={`sourced-logo ${className}`.trim()}
      style={{ gap: Math.round(height * 0.38) }}
      role="img"
      aria-label="Sourced"
    >
      {showEmblem && <SourcedEmblem height={height * 1.25} />}
      <SourcedWordmark height={height} />
    </span>
  );
}

/** Short hand-drawn orange stroke, as under "Sign up for beta" in the app. */
export function AccentUnderline({ width = 72, className = '' }) {
  return (
    <svg
      className={`accent-underline ${className}`.trim()}
      width={width}
      height={7}
      viewBox="0 0 72 7"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <path
        d="M1 4.6 C 25 -0.5, 50 8.5, 71 2.4"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}
